/* Granata Music – product page redesign.
   Add to cart itself is handled by the theme's <form is="product-form">, which also
   adds the setup service (name="bundles" checkbox) and opens the cart drawer. */
(() => {
  if (window.__gmPdpLoaded) return;
  window.__gmPdpLoaded = true;

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function formatMoney(cents, format) {
    const value = (Number(cents) || 0) / 100;
    const fmt = (n, decimals, thousands, decimal) => {
      const [whole, frac] = n.toFixed(decimals).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        default: return fmt(value, 2, ',', '.');
      }
    });
  }

  /* Sticky offsets: header and the theme's mobile dock. The theme hides its header on scroll by
     translating the inner <header> while the sticky section keeps its box, so measure the inner one. */
  function updateOffsets() {
    let top = 0;
    $$('.shopify-section-group-header-group').forEach((section) => {
      const pos = getComputedStyle(section).position;
      if (pos !== 'sticky' && pos !== 'fixed') return;
      const r = ($('header', section) || section).getBoundingClientRect();
      if (r.bottom > 0) top = Math.max(top, r.bottom);
    });
    document.documentElement.style.setProperty('--gm-sticky-top', `${Math.max(0, Math.round(top))}px`);

    const dock = $('mobile-dock, .mobile-dock, #shopify-section-mobile-dock .mobile-dock');
    let dockH = 0;
    if (dock) {
      const r = dock.getBoundingClientRect();
      const cs = getComputedStyle(dock);
      if (cs.display !== 'none' && cs.visibility !== 'hidden' && r.height && r.top < window.innerHeight) {
        dockH = Math.max(0, window.innerHeight - r.top);
      }
    }
    document.documentElement.style.setProperty('--gm-dock-height', `${Math.round(dockH)}px`);
  }

  /* ───────── Gallery ───────── */
  function initGallery(root) {
    const gallery = $('[data-gm-gallery]', root);
    if (!gallery) return null;
    const track = $('[data-gm-track]', gallery);
    const slides = $$('[data-gm-slide]', gallery);
    const thumbs = $$('.gm-thumb', gallery);
    const dots = $$('.gm-dot', gallery);
    const counter = $('[data-gm-counter]', gallery);
    const prev = $('[data-gm-prev]', gallery);
    const next = $('[data-gm-next]', gallery);
    let index = 0;

    const setActive = (i) => {
      index = i;
      thumbs.forEach((t, n) => {
        t.classList.toggle('is-active', n === i);
        if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      if (counter) counter.textContent = String(i + 1);
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      const thumb = thumbs[i];
      if (thumb && thumb.parentElement.scrollHeight > thumb.parentElement.clientHeight) {
        thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      slides.forEach((s, n) => { if (n !== i) $$('video', s).forEach((v) => v.pause()); });
    };

    const goTo = (i, smooth = true) => {
      const clamped = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[clamped].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      setActive(clamped);
    };

    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== index && slides[i]) setActive(i);
      });
    }, { passive: true });

    [...thumbs, ...dots].forEach((b) => b.addEventListener('click', () => goTo(Number(b.dataset.gmThumb))));
    prev?.addEventListener('click', () => goTo(index - 1));
    next?.addEventListener('click', () => goTo(index + 1));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
    });
    window.addEventListener('resize', () => goTo(index, false));

    /* Lightbox */
    const dialog = $('[data-gm-lightbox]', root);
    const img = $('[data-gm-lightbox-img]', root);
    const images = slides.map((s) => $('img[data-gm-zoom-src]', s));
    let lbIndex = 0;
    const showLb = (i) => {
      const imageIdx = [];
      images.forEach((im, n) => { if (im) imageIdx.push(n); });
      if (!imageIdx.length || !dialog) return;
      let pos = imageIdx.indexOf(i);
      if (pos < 0) pos = 0;
      lbIndex = (pos + imageIdx.length) % imageIdx.length;
      const im = images[imageIdx[lbIndex]];
      img.src = im.dataset.gmZoomSrc;
      img.alt = im.alt;
      dialog.dataset.list = imageIdx.join(',');
      if (!dialog.open) dialog.showModal();
    };
    const stepLb = (d) => {
      const list = (dialog.dataset.list || '').split(',').map(Number);
      if (!list.length) return;
      lbIndex = (lbIndex + d + list.length) % list.length;
      const im = images[list[lbIndex]];
      img.src = im.dataset.gmZoomSrc;
      img.alt = im.alt;
    };
    $('[data-gm-zoom]', root)?.addEventListener('click', () => showLb(index));
    slides.forEach((s, n) => $('img[data-gm-zoom-src]', s)?.addEventListener('click', () => showLb(n)));
    $('[data-gm-lightbox-close]', root)?.addEventListener('click', () => dialog.close());
    $('[data-gm-lightbox-prev]', root)?.addEventListener('click', () => stepLb(-1));
    $('[data-gm-lightbox-next]', root)?.addEventListener('click', () => stepLb(1));
    dialog?.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    dialog?.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') stepLb(1);
      if (e.key === 'ArrowLeft') stepLb(-1);
    });

    setActive(0);
    return { goTo };
  }

  /* ───────── Buy box ───────── */
  function initProduct(root) {
    const gallery = initGallery(root);
    const config = JSON.parse($('[data-gm-config]', root)?.textContent || '{}');
    const variants = JSON.parse($('[data-gm-variant-json]', root)?.textContent || '[]');
    const formId = root.dataset.formId;
    const form = document.getElementById(formId);
    const idInput = form?.querySelector('input[name="id"]');
    const qtyInput = $('[data-gm-qty] input', root);
    const setup = $('[data-gm-setup]', root);
    let current = variants.find((v) => String(v.id) === idInput?.value) || variants[0];

    const atcLabels = () => $$('[data-gm-atc-label]', root);
    const atcButtons = () => $$('[data-gm-atc], [data-gm-atc-mirror]', root);

    function labelFor(v) {
      if (!v) return 'Unavailable';
      if (!v.available) return 'Sold out';
      return setup?.checked ? (setup.dataset.cartLabel || 'Add to cart with add-on') : 'Add to cart';
    }
    function refreshAtc() {
      atcLabels().forEach((el) => { el.textContent = labelFor(current); });
      atcButtons().forEach((b) => { b.disabled = !current || !current.available; });
    }

    /* Quantity */
    function qtyMax() {
      if (!current || current.qty === null || current.qty <= 0) return null;
      return current.deny || config.capQty ? current.qty : null;
    }
    function syncQty() {
      if (!qtyInput) return;
      const max = qtyMax();
      if (max) qtyInput.max = max; else qtyInput.removeAttribute('max');
      let val = parseInt(qtyInput.value, 10) || 1;
      val = Math.max(1, max ? Math.min(max, val) : val);
      qtyInput.value = val;
      $('[data-gm-qty-minus]', root).disabled = val <= 1;
      $('[data-gm-qty-plus]', root).disabled = !!max && val >= max;
    }
    $('[data-gm-qty-minus]', root)?.addEventListener('click', () => { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) - 1; syncQty(); });
    $('[data-gm-qty-plus]', root)?.addEventListener('click', () => { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; syncQty(); });
    qtyInput?.addEventListener('change', syncQty);

    setup?.addEventListener('change', refreshAtc);

    /* Variant change */
    function renderVariant(v) {
      const money = (c) => formatMoney(c, config.moneyFormat);
      const onSale = v && v.compare > v.price;
      $$('[data-gm-price-now]', root).forEach((el) => {
        el.textContent = v ? money(v.price) : '';
        el.classList.toggle('is-sale', !!onSale);
      });
      $$('[data-gm-price-was]', root).forEach((el) => { el.hidden = !onSale; if (onSale) el.textContent = money(v.compare); });
      const save = $('[data-gm-price-save]', root);
      if (save) save.hidden = !onSale;
      if (onSale) {
        $('[data-gm-save-amount]', root).textContent = money(v.compare - v.price);
        $('[data-gm-save-percent]', root).textContent = Math.round(((v.compare - v.price) * 100) / v.compare);
      }
      const badgeSave = $('[data-gm-badge-save]', root);
      if (badgeSave) badgeSave.hidden = !onSale;
      const low = v && v.qty !== null && v.qty > 0 && v.qty <= config.lowStock;
      const badgeStock = $('[data-gm-badge-stock]', root);
      if (badgeStock) { badgeStock.hidden = !low; if (low) $('[data-gm-stock-qty]', root).textContent = v.qty; }
      const sku = $('[data-gm-sku]', root);
      if (sku) { sku.hidden = !(v && v.sku); if (v && v.sku) $('[data-gm-sku-value]', root).textContent = v.sku; }
      const rewards = $('[data-gm-rewards]', root);
      if (rewards && v) $('[data-gm-points]', rewards).textContent = Math.floor((v.price / 100) * Number(rewards.dataset.rate));
      const orderStatus = $('[data-gm-order-status]', root);
      if (orderStatus) orderStatus.hidden = !(v && v.qty !== null && v.qty <= 0 && !v.deny);
      const notify = $('[data-gm-notify]', root);
      if (notify) notify.hidden = !v || v.available;
      refreshAtc();
      syncQty();
    }

    function onOptionChange() {
      const selected = $$('[data-gm-variants] fieldset', root).map((fs) => $('input:checked', fs)?.value);
      $$('[data-gm-option-label]', root).forEach((el, i) => { el.textContent = selected[i] || ''; });
      current = variants.find((v) => v.options.every((o, i) => o === selected[i]));
      if (current && idInput) {
        idInput.value = current.id;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', current.id);
        window.history.replaceState({}, '', url.toString());
        if (current.media !== null && gallery) gallery.goTo(current.media);
        refreshPickup(current.id);
      }
      markUnavailable();
      renderVariant(current);
    }

    /* Grey out option values that have no available variant with the other current selections. */
    function markUnavailable() {
      const fieldsets = $$('[data-gm-variants] fieldset', root);
      const selected = fieldsets.map((fs) => $('input:checked', fs)?.value);
      fieldsets.forEach((fs, optIdx) => {
        $$('input', fs).forEach((input) => {
          const combo = selected.slice();
          combo[optIdx] = input.value;
          const match = variants.find((v) => v.options.every((o, i) => o === combo[i]));
          input.closest('.gm-chip').classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    async function refreshPickup(variantId) {
      const holder = $('[data-gm-pickup]', root);
      if (!holder) return;
      try {
        const res = await fetch(`${root.dataset.productUrl}?variant=${variantId}&section_id=${config.pickupSection}`);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const section = doc.querySelector('.shopify-section') || doc.body;
        holder.innerHTML = section.innerHTML;
      } catch (e) { /* keep previous pickup line */ }
    }

    $$('[data-gm-variants] input', root).forEach((input) => input.addEventListener('change', onOptionChange));
    if ($('[data-gm-variants]', root)) markUnavailable();
    syncQty();
    refreshAtc();

    /* Some apps inject a hidden clone of name="add" buttons ahead of ours, so the theme's
       loading state can land on the clone. Mirror it onto the visible buttons ourselves. */
    const setBusy = (busy) => atcButtons().forEach((b) => {
      if (busy) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    });
    form?.addEventListener('submit', () => {
      setBusy(true);
      setTimeout(() => setBusy(false), 8000);
    });
    document.addEventListener('ajaxProduct:added', () => setBusy(false));
    document.addEventListener('ajaxProduct:error', () => setBusy(false));

    /* Mobile buy bar: visible once the main buy buttons scroll out of view. The wrapper is
       measured rather than the button because of the app clones mentioned above. */
    const bar = $('[data-gm-buybar]', root);
    const mainAtc = $('.gm-actions', root);
    if (bar && mainAtc) {
      const footer = $('.footer-group') || $$('footer').pop();
      const update = () => {
        const pastButtons = mainAtc.getBoundingClientRect().bottom < 0;
        const atFooter = footer && footer.getBoundingClientRect().top < window.innerHeight;
        const show = mobileQuery.matches && pastButtons && !atFooter;
        if (show === bar.classList.contains('is-visible')) return;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('button', bar).forEach((b) => { b.tabIndex = show ? 0 : -1; });
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
  }

  /* ───────── Recommendations (complementary + related) ───────── */
  async function loadRecs(el) {
    try {
      const res = await fetch(el.dataset.gmRecs);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = doc.querySelector('[data-gm-recs-content]');
      const target = $('[data-gm-recs-content]', el);
      if (content && content.innerHTML.trim() && target) {
        target.innerHTML = content.innerHTML;
        syncCarousels();
        if (el.dataset.gmNavPending) {
          el.dataset.gmNav = el.dataset.gmNavPending;
          buildSectionNav();
        }
      } else {
        el.hidden = true;
      }
    } catch (e) {
      el.hidden = true;
    }
  }

  /* ───────── Carousels ("Pairs well with") ─────────
     Arrows page through the row; they hide when everything fits and dim at either end. */
  function syncCarousel(track) {
    const wrap = track.closest('[data-gm-carousel-wrap]');
    const arrows = wrap && $('[data-gm-carousel-arrows]', wrap);
    if (!arrows) return;
    const max = track.scrollWidth - track.clientWidth;
    arrows.hidden = max <= 2;
    $('[data-gm-carousel-btn="prev"]', arrows).disabled = track.scrollLeft <= 2;
    $('[data-gm-carousel-btn="next"]', arrows).disabled = track.scrollLeft >= max - 2;
  }
  function syncCarousels() { $$('[data-gm-carousel]').forEach(syncCarousel); }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-gm-carousel-btn]');
    const track = btn && $('[data-gm-carousel]', btn.closest('[data-gm-carousel-wrap]'));
    if (!track) return;
    const card = track.firstElementChild;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    const perPage = Math.max(1, Math.floor((track.clientWidth + gap) / step));
    track.scrollBy({ left: (btn.dataset.gmCarouselBtn === 'next' ? 1 : -1) * step * perPage, behavior: 'smooth' });
  });
  document.addEventListener('scroll', (e) => {
    if (e.target instanceof Element && e.target.matches('[data-gm-carousel]')) syncCarousel(e.target);
  }, { capture: true, passive: true });
  window.addEventListener('resize', syncCarousels);

  /* ───────── Section nav ───────── */
  let navObserver;
  function buildSectionNav() {
    const nav = $('[data-gm-secnav]');
    const list = $('[data-gm-secnav-list]');
    if (!nav || !list) return;
    const targets = $$('[data-gm-nav]').filter((el) => !el.hidden && el.id && el.dataset.gmNav);
    list.innerHTML = '';
    targets.forEach((t) => {
      const a = document.createElement('a');
      a.href = `#${t.id}`;
      a.textContent = t.dataset.gmNav;
      a.dataset.target = t.id;
      list.appendChild(a);
    });
    nav.classList.toggle('is-empty', targets.length < 2);

    navObserver?.disconnect();
    const setActive = (id) => {
      $$('a', list).forEach((a) => {
        const active = a.dataset.target === id;
        a.classList.toggle('is-active', active);
        if (active) {
          a.setAttribute('aria-current', 'true');
          const l = a.offsetLeft - 16;
          if (l < list.scrollLeft || a.offsetLeft + a.offsetWidth > list.scrollLeft + list.clientWidth) list.scrollTo({ left: l, behavior: 'smooth' });
        } else a.removeAttribute('aria-current');
      });
    };
    const visible = new Map();
    navObserver = new IntersectionObserver((entries) => {
      entries.forEach((e) => visible.set(e.target.id, e.isIntersecting ? e.boundingClientRect.top : null));
      const first = targets.find((t) => visible.get(t.id) !== null && visible.get(t.id) !== undefined);
      if (first) setActive(first.id);
    }, { rootMargin: '-35% 0px -55% 0px' });
    targets.forEach((t) => navObserver.observe(t));
    if (targets[0]) setActive(targets[0].id);
  }

  /* "Show more" toggle for a block that's been cut short with a CSS class. */
  function addToggle(el, cls, moreLabel, lessLabel) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gm-btn gm-btn--soft gm-btn--sm gm-more';
    btn.textContent = moreLabel;
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', () => {
      const open = el.classList.toggle(cls) === false;
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? lessLabel : moreLabel;
      if (!open) el.scrollIntoView({ block: 'start' });
    });
    el.after(btn);
    return btn;
  }

  /* Specs: grouped panels become accordions on mobile (all closed); otherwise a tall panel shows a preview. */
  function syncSpecs() {
    $$('[data-gm-specs]').forEach((panel) => {
      // The flat layout (no group headings) wraps everything in one headless group: keep it open.
      const groups = panel.classList.contains('gm-specs--flat') ? [] : $$('details', panel);
      groups.forEach((d) => { d.open = !mobileQuery.matches; });
      if (panel.dataset.gmPreview) return;
      panel.dataset.gmPreview = '1';
      if ((mobileQuery.matches && groups.length) || panel.scrollHeight <= (mobileQuery.matches ? 300 : 340)) return;
      const rows = $$('.gm-kv__row', panel).length;
      panel.classList.add('is-collapsed');
      addToggle(panel, 'is-collapsed', `Show all specifications (${rows})`, 'Show fewer specifications');
    });
  }

  /* Long overview copy (written in the product's overview field) gets "Read more".
     Descriptions shown in its place have their own collapse in the overview section. */
  function clampOverview() {
    $$('.gm-overview__body').forEach((body) => {
      if (body.dataset.gmClamp || $('.gm-desc', body)) return;
      body.dataset.gmClamp = '1';
      if (body.scrollHeight <= 360) return;
      body.classList.add('gm-clampable', 'is-clamped');
      addToggle(body, 'is-clamped', 'Read more', 'Show less');
    });
  }

  function init() {
    $$('[data-gm-product]').forEach((root) => {
      if (root.dataset.gmReady) return;
      root.dataset.gmReady = 'true';
      initProduct(root);
    });
    $$('[data-gm-recs]').forEach((el) => { if (!el.dataset.gmLoaded) { el.dataset.gmLoaded = '1'; loadRecs(el); } });
    buildSectionNav();
    syncSpecs();
    clampOverview();
    updateOffsets();
    syncCarousels();
  }

  /* The theme header animates its height while scrolling, so re-measure after it settles too. */
  let offsetRaf;
  let offsetTimer;
  window.addEventListener('scroll', () => {
    cancelAnimationFrame(offsetRaf);
    offsetRaf = requestAnimationFrame(updateOffsets);
    clearTimeout(offsetTimer);
    offsetTimer = setTimeout(updateOffsets, 350);
  }, { passive: true });
  window.addEventListener('resize', updateOffsets);
  if ('ResizeObserver' in window) {
    const headerObserver = new ResizeObserver(updateOffsets);
    $$('.shopify-section-group-header-group').forEach((el) => headerObserver.observe(el));
  }
  $$('.shopify-section-group-header-group header').forEach((el) => el.addEventListener('transitionend', updateOffsets));
  mobileQuery.addEventListener?.('change', syncSpecs);
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
